/* eslint-disable no-dupe-keys */
export default {
  vip_member: {
    // 属性（一般与对象内容匹配）
    prop: {
      user: '用户',
      expiration_time: '到期时间',
      remaining_days: '剩余天数',
      latest_renewal_time: '最近续费时间',
      latest_renewal_months_count: '最近续费类型',
      total_renewal_months_count: '总续费月数',
      discount_orders_count: '总优惠订单数',
      discount_orders_amount: '总优惠金额',
      month_discount_orders_count: '月优惠次数',
      month_discount_amount: '最近月优惠金额',
      month_max_discount_amount: '最大月优惠金额',
      created_at: '创建时间',
      updated_at: '更新时间',
      status: '会员状态'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询昵称/手机/描述'
    },
    // 标题
    // 会员状态
    statuses: {
      active: '生效中',
      inactive: '已失效'
    },
    list_tabs: {
      all: '全部',
      active: '生效中',
      inactive: '失效的'
    }
  }
}
